import { IUserSubscriptionModel } from "@nf/common";
import dynamic from "next/dynamic";
import { useState } from "react";
import { useCurrentSubscriptions, usePreviousSubscriptions } from "hooks";
import { CurrentSubscriptionContainer } from "../CurrentSubscriptionContainer/CurrentSubscriptionContainer";
import { PreviousSubscriptionContainer } from "../PreviousSubscriptionContainer/PreviousSubscriptionContainer";

const CancellationDialog = dynamic(
  () => import("components/CancellationDialog/CancellationDialog"),
  { ssr: false }
);

type TActiveSubscriptionsContainerProps = {
  subscriptions: IUserSubscriptionModel[];
};

export const ActiveSubscriptionsContainer = ({
  subscriptions,
}: TActiveSubscriptionsContainerProps): JSX.Element => {
  const { currentSubscriptions, hasCurrentSubscriptions } =
    useCurrentSubscriptions(subscriptions);
  const { previousSubscriptions, hasPreviousSubscriptions } =
    usePreviousSubscriptions(subscriptions);

  const [subscriptionToCancel, setSubscriptionToCancel] =
    useState<IUserSubscriptionModel>();

  const toggleCancellationDialog = (subscription?: IUserSubscriptionModel) => {
    setSubscriptionToCancel(subscriptionToCancel ? undefined : subscription);
  };

  return (
    <>
      {hasCurrentSubscriptions && (
        <CurrentSubscriptionContainer
          currentSubscriptions={
            currentSubscriptions as IUserSubscriptionModel[]
          }
          hasActiveSub={true}
          onCancel={toggleCancellationDialog}
        />
      )}
      {hasPreviousSubscriptions && (
        <PreviousSubscriptionContainer
          hasActiveSub={hasCurrentSubscriptions}
          previousSubscriptions={
            previousSubscriptions as IUserSubscriptionModel[]
          }
        />
      )}

      {subscriptionToCancel && (
        <CancellationDialog
          subscription={subscriptionToCancel}
          visible={!!subscriptionToCancel}
          onCancel={toggleCancellationDialog}
        />
      )}
    </>
  );
};
